<script lang="ts">
  import Heading from "./Heading.svelte";

  export let id: string | undefined = undefined;
</script>

<Heading level={2} {id}>
  <slot />
</Heading>
